import type { I18nT } from '@runtime/core/i18n/i18n'

export function strategyHelpTabs(t: I18nT) {
  return ['objective', 'board', 'turn', 'hand', 'options'].map(id => ({
    id,
    label: t(`strategy.help.how.tabs.${id}`),
    content: t(`strategy.help.how.${id}`),
  }))
}
